import { parse } from 'qs';


export const getAll = (location = {}) => parse(location.search, { ignoreQueryPrefix: true });
export const get = (location, key) => getAll(location)[key];
export const set = (location, params) => ({ ...getAll(location), ...params });
export const remove = (location, key, value) => {
  const existingQueryParams = getAll(location);
  const existingQueryValue = existingQueryParams[key];
  if (value && Array.isArray(existingQueryValue)) {
    const remainingValue = existingQueryValue.filter((queryValue) => queryValue !== value);
    if (remainingValue.length) {
      return { ...existingQueryParams, [key]: remainingValue };
    }
    delete existingQueryParams[key];
  } else {
    delete existingQueryParams[key];
  }
  return existingQueryParams;
};
